const fonts = {
    'FONTFAMILY_Arial': {
        fontFamily: '"Arial", sans-serif',
        label: 'Arial',
    },
    'FONTFAMILY_Arial-Black': {
        fontFamily: '"Arial Black", sans-serif',
        label: 'Arial Black',
    },
    'FONTFAMILY_Arial-Narrow': {
        fontFamily: '"Arial Narrow", sans-serif',
        label: 'Arial Narrow',
    },
    'FONTFAMILY_Calibri': {
        fontFamily: '"Calibri", "Arial", sans-serif',
        label: 'Calibri'
    },
    'FONTFAMILY_CenturyGothic': {
        fontFamily: '"Century Gothic", "Arial", sans-serif',
        label: 'Century Gothic'
    },
    'FONTFAMILY_Courier': {
        fontFamily: '"Courier"',
        label: 'Courier'
    },
    'FONTFAMILY_Georgia': {
        fontFamily: '"Georgia", serif',
        label: 'Georgia'
    },
    'FONTFAMILY_GillSans': {
        fontFamily: '"Gill Sans", "Arial", sans-serif',
        label: 'Gill Sans'
    },
    'FONTFAMILY_Helvetica': {
        fontFamily: '"Helvetica", "Arial", sans-serif',
        label: 'Helvetica'
    },
    'FONTFAMILY_Tahoma': {
        fontFamily: '"Tahoma", "Arial", sans-serif',
        label: 'Tahoma'
    },
    'FONTFAMILY_TimesNewRoman': {
        fontFamily: '"Times New Roman", serif',
        label: 'Times New Roman'
    },
    'FONTFAMILY_TrebuchetMS': {
        fontFamily: '"Trebuchet MS", "Arial", sans-serif',
        label: 'Trebuchet MS'
    },
    'FONTFAMILY_Verdana': {
        fontFamily: '"Veranda", "Arial", sans-serif',
        label: 'Verdana'
    },
}

export default fonts;
